module.exports = __webpack_public_path__ + "img/c2.7e381cf9.png";